import React, {Fragment} from 'react'
//import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import { confirmAlert } from 'react-confirm-alert'
import 'react-confirm-alert/src/react-confirm-alert.css'

const divStyle = {
  paddingLeft: '0px',
}

const linkStyle = {
  fontWeight: 'normal',
  color: 'black',
  paddingRight: '10px',
  border: 'none',
}

const aStyle = {
  display: 'none',
}

const tableStyle = {
  backgroundColor: '#ffffff',
}

const div2Style = {
  float: 'left',
  paddingLeft: '0px',
}

class Details extends React.Component {
  constructor(props) {
    super(props)
  }

  handleSubmit(id) {
    let urlf = '/api/v1/documents/'
    urlf = urlf + id
    confirmAlert({
      title: 'Confirm',
      message: 'Are you sure to delete this document?',
      buttons: [
        {
          label: 'Yes',
          onClick: () => {
            fetch(urlf, {
              method: 'DELETE',
              headers: {
                'Content-Type': 'application/json',
              },
            })
            .then(response => response.json())
            .then(() => {
              document.getElementById('mylink').click()
            })
            .catch((err) => {
              console.error('Error while deleting document! ' + err)
            })
          },
        },
        {
          label: 'No',
          onClick: () => {
            document.getElementById('react-confirm-alert').close
          },
        },
      ],
    })
  }

  renderHeaderId() {
    return <Fragment><th key="cnp">CNP</th><th key="series">Series</th><th key="number">Number</th><th key="title">Title</th><th key="issue">Date of issue</th><th key="actions" colSpan="2">Actions</th></Fragment>
  }

  renderDataId() {
    const myData = [].concat(Object.values(this.props.employee.employee.id_documents))
    return Object.keys(myData).map((key) => {
      const doc = myData[key]
      const l = '/users/' + doc['doc']['user_id'] + '/document_edit/' + doc['doc']['id']
      const le = doc['ld']
      return <tr key={key}><td>{doc['doc']['cnp']}</td><td>{doc['doc']['series']}</td><td>{doc['doc']['number']}</td><td>{doc['doc']['title']}</td><td>{doc['doc']['date']}</td><td colSpan="2"><span>{ le !== '' && <a href={le} style={linkStyle}>                                             View</a>}<a href={l} style={linkStyle}>Update</a><a href="#" onClick={() => this.handleSubmit(doc['doc']['id'])} style={linkStyle}>Delete</a></span></td></tr>
    }
    )
  }

  renderHeaderQua() {
    return <Fragment><th key="series">Series</th><th key="number">Number</th><th key="title">Title</th><th key="issue">Date of issue</th><th key="actions" colSpan="2">Actions</th></Fragment>
  }

  renderDataQua() {
    const myData = [].concat(Object.values(this.props.employee.employee.qualification_documents))
    return Object.keys(myData).map((key) => {
      const doc = myData[key]
      const l = '/users/' + doc['doc']['user_id'] + '/document_edit/' + doc['doc']['id']
      const le = doc['ld']
      return <tr key={key}><td>{doc['doc']['series']}</td><td>{doc['doc']['number']}</td><td>{doc['doc']['title']}</td><td>{doc['doc']['date']}</td><td colSpan="2"><span>{ le !== '' && <a href={le} style={linkStyle}>                                               View</a>}<a href={l} style={linkStyle}>Update</a><a href="#" onClick={() => this.handleSubmit(doc['doc']['id'])} style={linkStyle}>Delete</a></span></td></tr>
    }
    )
  }

  renderHeaderOth() {
    return <Fragment><th key="series">Series</th><th key="number">Number</th><th key="title">Title</th><th key="issue">Date of issue</th><th key="actions" colSpan="2">Actions</th></Fragment>
  }

  renderDataOth() {
    const myData = [].concat(Object.values(this.props.employee.employee.other_documents))
    return Object.keys(myData).map((key) => {
      const doc = myData[key]
      const l = '/users/' + doc['doc']['user_id'] + '/document_edit/' + doc['doc']['id']
      const le = doc['ld']
      return <tr key={key}><td>{doc['doc']['series']}</td><td>{doc['doc']['number']}</td><td>{doc['doc']['title']}</td><td>{doc['doc']['date']}</td><td colSpan="2"><span>{ le !== '' && <a href={le} style={linkStyle}>                                                 View</a>}<a href={l} style={linkStyle}>Update</a><a href="#" onClick={() => this.handleSubmit(doc['doc']['id'])} style={linkStyle}>Delete</a></span></td></tr>
    }
    )
  }

  render() {
    if (this.props.employee.employee) {
      const empl = this.props.employee.employee
      let dateBirth = ''
      let sex = ''
      let nationality = ''
      let email = ''
      let telephone = ''
      let address = ''
      let teams = ''
      let hiring = ''
      let promotion = ''
      let end = ''
      let contractno = ''
      let position = ''
      let contracttype = ''
      const nothing = '-'
      if (empl.date_of_birth === null){
        dateBirth = ' -'
      } else {
        dateBirth = ' ' + empl.date_of_birth
      }
      if (empl.sex === null){
        sex = ' -'
      } else {
        sex = ' ' + empl.sex
      }
      if (empl.nationality === null){
        nationality = ' -'
      } else {
        nationality = ' ' + empl.nationality
      }
      if (empl.email === null){
        email = ' -'
      } else {
        email = ' ' + empl.email
      }
      if (empl.telephone === null){
        telephone = ' -'
      } else {
        telephone = ' ' + empl.telephone
      }
      if (empl.address === ''){
        address = ' -'
      } else {
        address = ' ' + empl.address
      }
      if (empl.teams === ''){
        teams = ' -'
      } else {
        teams = ' ' + empl.teams
      }
      if (empl.hiring_date === null){
        hiring = ' -'
      } else {
        hiring = ' ' + empl.hiring_date
      }
      if (empl.last_promotion === null){
        promotion = ' -'
      } else {
        promotion = ' ' + empl.last_promotion
      }
      if (empl.end_of_collaboration === null){
        end = ' -'
      } else {
        end = ' ' + empl.end_of_collaboration
      }
      if (empl.contract_no === ''){
        contractno = ' -'
      } else {
        contractno = ' ' + empl.contract_no
      }
      if (empl.position === ''){
        position = ' -'
      } else {
        position = ' ' + empl.position
      }
      if (empl.contract_type === ''){
        contracttype = ' -'
      } else {
        contracttype = ' ' + empl.contract_type
      }
      const l = '/employee_details/' + empl.id
      return <div style={divStyle}><a href={l} id="mylink" style={aStyle}></a><div className="row col-sm-12"><div className="col-sm-6" style={div2Style}><p><b>Date of birth:</b>{dateBirth}</p><p><b>Sex:</b>{sex}</p><p><b>Nationality:</b>{nationality}</p><p><b>Email:</b>{email}</p><p><b>Telephone:</b>{telephone}</p><p><b>Address:</b>{address}</p></div><div className="col-sm-6" style={div2Style}><p><b>Salary:</b>{empl.salary} RON</p><p><b>Working hours:</b>{empl.nr_working_hours} hours</p><p><b>Teams:</b>{teams}</p><p><b>Hiring date:</b>{hiring}</p><p><b>Last promotion date:</b>{promotion}</p><p><b>Contract number/date:</b>{contractno}</p><p><b>Contract duration type:</b>{contracttype}</p><p><b>Position:</b>{position}</p><p><b>End of collaboration date:</b>{end}</p></div></div><div><b>Id Documents:</b>{ empl.id_documents.length > 0 && <table className="table table-bordered" style={tableStyle}><tbody><tr>{this.renderHeaderId()}</tr>{this.renderDataId()}</tbody></table>}{ empl.id_documents.length === 0 && <span>                                                     {nothing}<br /></span>}</div><div><b>Qualification Documents:</b>{ empl.qualification_documents.length > 0 && <table className="table table-bordered" style={tableStyle}><tbody><tr>{this.renderHeaderQua()}</tr>{this.renderDataQua()}</tbody></table>}{ empl.qualification_documents.length === 0 && <span>                                                             {nothing}<br /></span>}</div><div><b>Other Documents:</b>{ empl.other_documents.length > 0 && <table className="table table-bordered" style={tableStyle}><tbody><tr>{this.renderHeaderOth()}</tr>{this.renderDataOth()}</tbody></table>}{ empl.other_documents.length === 0 && <span>                                                     {nothing}<br /></span>}</div></div>
    } else {
      return <div></div>
    }
  }
}

Details.propTypes = {
  employee: PropTypes.object.isRequired,
}

export default Details
